import React, { useRef, useState } from 'react';
import { 
  DesktopMenuWrapper, 
  MobileMenuWrapper, 
  HeaderLogo, 
  HeaderLogoImage, 
  HeaderMenuList,
  HeaderNavArea, 
  MenuItemLink, 
  OurProjectsLink, 
  HeaderColumn, 
  OurProjectsLinkMobile, 
  MenuItemLinkMobile,
  ProductsDropdownToggle,
  ProductsMenuItemLink,
  OverlayBackdrop,
  OverlayPanel,
  OverlayCloseButton,
  OverlayContent,
  ProductsDropdownItem,
  NotificationBadge,
  HeaderLogoMobile,
  NotificationBadgeMobile,
  ContactUsMenuItemLink,
  ContactUsDropdownToggle,
  ContactUsDropdownItem,
  MarketplaceMenuItemLink,
  MarketplaceDropdownToggle,
  MarketplaceDropdownItem
} from "./Header.styled";
import { COMPANY_EMAIL, COMPANY_MOBILE_NO, MENU_ITEMS, PRODUCT_CATEGORIES, SHOPEE_LINK, TOKOPEDIA_LINK, WHATSAPP_LINK } from '../../utils/constants'
import companyLogo from '../../assets/logo.png';
import { Dropdown, Row } from 'react-bootstrap';
import { GiHamburgerMenu } from 'react-icons/gi';
import { FiChevronDown } from 'react-icons/fi';
import { RiCloseFill } from 'react-icons/ri';
import { slide as Menu } from 'react-burger-menu';
import { useNavigate } from 'react-router'

import '../../App.css';
import { BLACK } from '../../utils/colors';
import kebabToTitleCase from '../../utils/kebabToTitleCase';
import QuotationOverlay from '../QuotationOverlay/QuotationOverlay';

const Header = () => {

  const navigate = useNavigate();
  const products = JSON.parse(localStorage.getItem('products')) || {};

  const productsTimeoutRef = useRef(null);
  const contactUsTimeoutRef = useRef(null);

  const [openMobileMenu, setOpenMobileMenu] = useState(false);
  const [showProducts, setShowProducts] = useState(false);
  const [quotationSidebarOpen, setQuotationSidebarOpen] = useState(false);
  const [showProductsDropdown, setShowProductsDropdown] = useState(false);
  const [showContactUsDropdown, setShowContactUsDropdown] = useState(false);

  const handleSidebarOpen = (evt) => {
    setOpenMobileMenu(true);
  }

  const handleSidebarClose = () => {
    setOpenMobileMenu(false);
  }

  const handleContactUsMouseEnter = (type) => {
    switch (type) {
      case 'contact-us':
        if (contactUsTimeoutRef.current) clearTimeout(contactUsTimeoutRef.current);
        setShowContactUsDropdown(true);
        return;
      case 'products':
        if (productsTimeoutRef.current) clearTimeout(productsTimeoutRef.current);
        setShowProductsDropdown(true);
        return;
      default:
        setShowContactUsDropdown(false);
        setShowProductsDropdown(false);
        return;
    }
  };

  const handleContactUsMouseLeave = (type) => {
    switch (type) {
      case 'contact-us':
        contactUsTimeoutRef.current = setTimeout(() => setShowContactUsDropdown(false), 200);
        return;
      case 'products':
        productsTimeoutRef.current = setTimeout(() => setShowProductsDropdown(false), 200);
        return;
      default:
        setShowContactUsDropdown(false);
        setShowProductsDropdown(false);
        return;
    }
  };

  const handleQuotationButtonClick = () => {
    handleSidebarClose();
    setQuotationSidebarOpen(true);
  }

  const onWhatsappClick = () => {
    window.open(WHATSAPP_LINK, '_blank', 'noopener,noreferrer');
  }

  return (
    <header>
      <HeaderNavArea fluid>
        <Row>
          <HeaderColumn>
            <HeaderLogoMobile>
              <HeaderLogoImage src={companyLogo} alt="Company Logo" onClick={() => navigate('/')} />
            </HeaderLogoMobile>
            <DesktopMenuWrapper role="navigation">
              <HeaderMenuList>
                {MENU_ITEMS.map((menu) => {
                  if(menu.label === "Request for Quotation") {
                    return null;
                  } else if(menu.label === "Products") {
                    return (
                      <div key={menu.label} style={{display: 'inline-block', position: 'relative'}} onMouseEnter={() => handleContactUsMouseEnter('products')} onMouseLeave={() => handleContactUsMouseLeave('products')}>
                        <ProductsMenuItemLink key={menu.label}>
                          <Dropdown 
                            show={showProductsDropdown} 
                            >
                            <ProductsDropdownToggle id="dropdown-basic">
                              Produk
                            </ProductsDropdownToggle>

                            <Dropdown.Menu>
                              {PRODUCT_CATEGORIES.map((category) => {
                                return (
                                  <ProductsDropdownItem
                                    key={category} 
                                    onClick={() => navigate(`/products?category=${category}`)}
                                  >
                                    {kebabToTitleCase(category)} {/* Convert kebab-case to title case */}
                                  </ProductsDropdownItem>
                                )
                              })}
                            </Dropdown.Menu>
                          </Dropdown>
                        </ProductsMenuItemLink>
                      </div>
                    )
                  } else if(menu.label === "Tentang Kami") {
                    return (
                      <div key={menu.label} style={{display: 'inline-block', position: 'relative'}}>
                        <MarketplaceMenuItemLink key={menu.label} to={menu.link}>
                          {menu.label}
                        </MarketplaceMenuItemLink>
                      </div>
                    )
                  } else if(menu.label === "Hubungi Kami") {
                    return (
                      <div key={menu.label} onMouseEnter={() => handleContactUsMouseEnter('contact-us')} onMouseLeave={() => handleContactUsMouseLeave('contact-us')} style={{display: 'inline-block', position: 'relative'}}>
                        <ContactUsMenuItemLink>
                          <Dropdown style={{borderRadius: '4px'}} 
                            show={showContactUsDropdown} 
                            >
                            <ContactUsDropdownToggle id="dropdown-contact-us">
                              {menu.label}
                            </ContactUsDropdownToggle>

                            <Dropdown.Menu onMouseEnter={() => setShowContactUsDropdown(true)} onMouseLeave={() => setShowContactUsDropdown(false)} >
                              <ContactUsDropdownItem
                                onClick={onWhatsappClick}
                              >
                                WhatsApp
                              </ContactUsDropdownItem>
                              <ContactUsDropdownItem
                                href={`mailto:${COMPANY_EMAIL}`}
                              >
                                Email
                              </ContactUsDropdownItem>
                            </Dropdown.Menu>
                          </Dropdown>
                        </ContactUsMenuItemLink>
                      </div>
                    )
                  } else if(menu.label === "logo") {
                    return (
                      <HeaderLogo key={menu.label} onClick={() => navigate('/')}>
                        <HeaderLogoImage src={companyLogo} alt="Company Logo" />
                      </HeaderLogo>
                    )
                  }
                  return (
                    <MenuItemLink key={menu.label} onClick={() => navigate(menu.link)}>{menu.label}</MenuItemLink>
                  );
                })}
              </HeaderMenuList>
              <div style={{position: 'absolute', right: '20px'}}>
                <OurProjectsLink onClick={() => setQuotationSidebarOpen(true)}>
                  {products && Object.keys(products).length > 0 && (
                    <NotificationBadge>
                      {Object.keys(products).length}
                    </NotificationBadge>
                  )}
                  Request for Quotation
                </OurProjectsLink>
              </div>
              
            </DesktopMenuWrapper>
            <MobileMenuWrapper role="navigation">
              <Menu 
                width="60%" 
                right 
                onOpen={handleSidebarOpen} 
                onClose={handleSidebarClose} 
                isOpen={openMobileMenu} 
                customBurgerIcon={
                  <GiHamburgerMenu size={25} color={BLACK} />
                } 
                customCrossIcon={
                  <RiCloseFill size={33} color={BLACK} />
                }
                disableAutoFocus
                noOverlay={false}
                outerContainerId="outer-container"
              >
                {MENU_ITEMS.map((menu) => {
                  if(menu.label === 'logo') {
                    return null;
                  } else if(menu.label === "Request for Quotation") {
                    return (
                      <OurProjectsLinkMobile onClick={handleQuotationButtonClick} key={menu.label}>
                        {products && Object.keys(products).length > 0 && (
                          <NotificationBadgeMobile>
                            {Object.keys(products).length}
                          </NotificationBadgeMobile>
                        )}
                        {menu.label}
                      </OurProjectsLinkMobile>
                    )
                  } else if(menu.label === "Products") {
                    return (
                      <div key={menu.label}>
                        <MenuItemLinkMobile onClick={() => setShowProducts(!showProducts)}>
                          Produk
                          <FiChevronDown style={{ marginLeft: '4px' }} />
                        </MenuItemLinkMobile>
                        {showProducts && (
                          <div style={{ paddingLeft: '1.5rem' }}>
                            {PRODUCT_CATEGORIES.map((category) => {
                              return (
                                <MenuItemLinkMobile
                                  key={category} 
                                  onClick={() => navigate(`/products?category=${category}`)}
                                >
                                  {kebabToTitleCase(category)} {/* Convert kebab-case to title case */}
                                </MenuItemLinkMobile>
                              )
                            })}
                          </div>
                        )}
                      </div>
                    )
                  } else if(menu.label === "Hubungi Kami") {
                    return (
                      <div key={menu.label}>
                        <MenuItemLinkMobile onClick={() => setShowContactUsDropdown(!showContactUsDropdown)}>
                          Hubungi Kami
                          <FiChevronDown style={{ marginLeft: '4px' }} />
                        </MenuItemLinkMobile>
                        {showContactUsDropdown && (
                          <div style={{ paddingLeft: '1.5rem' }}>
                            <MenuItemLinkMobile onClick={() => window.open(WHATSAPP_LINK, '_blank', 'noopener,noreferrer')}>WhatsApp</MenuItemLinkMobile>
                            <MenuItemLinkMobile href={`mailto:${COMPANY_EMAIL}`}>Email</MenuItemLinkMobile>
                          </div>
                        )}
                      </div>
                    )
                  }
                  return (
                    <MenuItemLinkMobile key={menu.label}>{menu.label}</MenuItemLinkMobile>
                  );
                })}
              </Menu>
            </MobileMenuWrapper>

            <>
              {quotationSidebarOpen && (
                <OverlayBackdrop onClick={() => setQuotationSidebarOpen(false)} />
              )}
              <OverlayPanel className={quotationSidebarOpen ? 'open' : ''}>
                {/* <button onClick={() => setQuotationSidebarOpen(false)}>Close</button> */}
                <OverlayCloseButton onClick={() => setQuotationSidebarOpen(false)}>
                  <RiCloseFill />
                </OverlayCloseButton>
                <OverlayContent>
                  <QuotationOverlay />
                </OverlayContent>
              </OverlayPanel>
            </>
          </HeaderColumn>
        </Row>
      </HeaderNavArea>
    </header>
  )
}

export default Header;